import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import {
  MatError,
  MatFormFieldAppearance,
  MatFormFieldModule,
} from "@angular/material/form-field";
import { MatCardModule } from "@angular/material/card";
import { MatNativeDateModule } from "@angular/material/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-date-picker",
  standalone: true,
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatError,
    CommonModule,
  ],
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.scss"],
})
export class DatePickerComponent {
  @Input() placeholder: string = "";
  @Input() error: string = "";
  @Input() limitToToday: boolean = false;
  @Input() agelimit: boolean = false;
  @Input() readonly: boolean = false;
  @Input() customWidth: string = "";
  @Input() minWidth: string = "";
  @Input() datestring: string | Date = "";
  @Input() appearance: MatFormFieldAppearance = "outline";
  @Output() dateSelected = new EventEmitter<Date>();
  @Input() dateControl: FormControl = new FormControl();
  maxDate: Date | null = null;
  maxAge: Date = new Date(
    new Date().setFullYear(new Date().getFullYear() - 16)
  );

  ngOnChanges() {
    this.updateMaxDate();
  }

  onDateChange(event: any) {
    this.dateSelected.emit(event.value);
    // Update maxDate when the age limit is applied
    if (this.agelimit) {
      this.maxDate = this.maxAge;
    }
  }
  get dateControlError() {
    if (this.dateControl.hasError("required")) {
      return "You must select a date";
    } else if (this.dateControl.hasError("max")) {
      return `Date cannot be later than ${this.maxDate?.toLocaleDateString()}`;
    }
    return "";
  }
  private updateMaxDate() {
    if (this.limitToToday) {
      this.maxDate = new Date(); // today
    } else if (this.agelimit) {
      this.maxDate = this.maxAge; // 15 years ago
    } else {
      this.maxDate = null; // No limit
    }
  }
}
